import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@lmc-env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class KapchargeConfigService {
  private readonly uri: string = `${environment.DO_URL}/v2/config/kapcharge`;

  constructor(private readonly http: HttpClient) {}

  getConfig(): Observable<any> {
    return this.http.get(this.uri);
  }

  updateGeneralConfig(data: { submitEnabled: boolean }): Observable<any> {
    return this.http.put(`${this.uri}/general`, data);
  }

  updateWebhookConfig(data: {
    webhookEnabled: boolean;
    webhookUrl: string;
    webhookAuthenticationHeader: string;
    subscribeStatuses: string[];
  }): Observable<any> {
    return this.http.put(`${this.uri}/webhook`, data);
  }
}
